import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../_images/refresh_qrcode.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-207532d7")

_pushScopeId("data-v-207532d7")
const _hoisted_1 = { class: "new-pay" }
const _hoisted_2 = { class: "bottom clearfix" }
const _hoisted_3 = { class: "pay-type" }
const _hoisted_4 = { class: "qrcode" }
const _hoisted_5 = { class: "dl_total" }
const _hoisted_6 = { class: "pay-title-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pay_scan_icon" }, null, -1)
const _hoisted_8 = { class: "pay-title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("打开"),
  /*#__PURE__*/_createVNode("em", null, "微信APP")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 扫一扫进行付款")
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "wechat_guide_trigger" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("打开"),
  /*#__PURE__*/_createVNode("em", { class: "alipay-tit" }, "支付宝APP")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 扫一扫进行付款")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "alipay_guide_trigger" }, null, -1)
const _hoisted_17 = { class: "total-dd" }
const _hoisted_18 = { class: "total" }
const _hoisted_19 = /*#__PURE__*/_createVNode("em", null, "￥", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("dl", _hoisted_3, [
        _createVNode("dd", null, [
          _createVNode("span", {
            class: _ctx.isWeChatPay ? 'wechat_type_sel' : 'wechat_type_def',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPayType(1)))
          }, null, 2),
          _createVNode("span", {
            class: _ctx.isAliPay ? 'alipay_type_sel' : 'alipay_type_def',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPayType(2)))
          }, null, 2)
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          (!_ctx.viewModel.isLogin || _ctx.viewModel.isExpires)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _imports_0,
                alt: "",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickDefaultQrImg && _ctx.clickDefaultQrImg(...args)))
              }))
            : (_openBlock(), _createBlock(_component_QrcodeVue, {
                key: 1,
                value: _ctx.viewModel.qrText,
                size: 110,
                level: "H"
              }, null, 8, ["value"]))
        ]),
        _createVNode("dl", _hoisted_5, [
          _createVNode("dd", null, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                (!_ctx.isAliPay)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("p", null, [
                        _hoisted_11,
                        _createVNode("span", {
                          onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPayGuide()))
                        }, [
                          _hoisted_12
                        ], 32)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("p", null, [
                        _hoisted_15,
                        _createVNode("span", {
                          onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPayGuide()))
                        }, [
                          _hoisted_16
                        ], 32)
                      ])
                    ]))
              ])
            ])
          ]),
          _createVNode("dd", _hoisted_17, [
            _createVNode("span", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(_toDisplayString(_ctx.currentPrice) + " ", 1),
              _withDirectives(_createVNode("span", { class: "total_off" }, "(已优惠 " + _toDisplayString(_ctx.discountPrice) + " 元)", 513), [
                [_vShow, _ctx.discountPrice]
              ])
            ])
          ])
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withId(() => [
            _withDirectives(_createVNode("div", {
              class: [_ctx.isAliPay ? 'alipay_guide_bg' : 'wechat_guide_bg', "common_guide"],
              onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPayGuide()))
            }, null, 34), [
              [_vShow, _ctx.viewModel.isPayGuide]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
})